import { apiClient, unwrap } from './client';
import type { ApiEnvelope } from './types';

/** One module's state for the caller's tenant, as the tenant-manifest export has it (API-10). */
export interface ModuleState {
  module: string;
  enabled: boolean;
  entitled: boolean;
  binding: string | null;
  reason: string;
}

export interface ModuleEntitlements {
  hubId: string;
  tenant: string;
  source: 'NOT_CONFIGURED' | 'LOADED' | 'UNREADABLE' | string;
  enforcement: string | null;
  modules: ModuleState[];
}

/** GET /v1/module-entitlements — what the caller's tenant may use. There is no write side. */
export async function getModuleEntitlements(): Promise<ModuleEntitlements> {
  const { data } = await apiClient.get<ApiEnvelope<ModuleEntitlements>>('/v1/module-entitlements');
  return unwrap(data);
}
